module.exports = {"370687001":"方圆街道","370687002":"东村街道","370687003":"凤城街道","370687004":"龙山街道","370687102":"留格庄镇","370687103":"盘石店镇","370687104":"郭城镇","370687105":"徐家店镇","370687106":"发城镇","370687107":"小纪镇","370687108":"行村镇","370687109":"辛安镇","370687110":"二十里店镇","370687112":"朱吴镇","370687401":"外向型工业加工区","370687402":"碧城工业区","370687403":"旅游度假区","370687404":"核电装备制造工业园区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/370687.json
// module id = 1411
// module chunks = 0